import widgetMixin from "./widget-mixin.js";
import feedURL from "./feed-url.js";

const photoTemplate = require('20220101/templates/widgets/event/photo.hbs');
const smallPhotoTemplate = require('20220101/templates/widgets/event/small-photo.hbs');
const indexTemplate = require('20220101/templates/widgets/event/index.hbs');

const DEFAULTS = {
  autoScrollDelay: 5000,
  numPhotos: 4,
  per: 50
}

class EventWidget extends widgetMixin(HTMLElement) {
  constructor() {
    super();

    this.DEFAULTS = DEFAULTS;
    this.photos = [];
    this.uniquePhotos = {};
    this.per = this.DEFAULTS.per;
    this.prevCount = 0;
    this.firstRender = true;
  }

  fetchLatest() {
    let params = { page: 1, per: 10 };
    let url = feedURL(this.photosURL, params);

    this.beforeFetch();

    return fetch(url)
      .then(response => response.json())
      .then((data) => {
        this.processPhotos(data);
        this.afterFetch();
      })
  }

  updatePhotos() {
    this.fetchPhotos().then(() => {

      this.renderMainPhoto();
      if (this.page === null) {
        this.page = 1;
      }
      this.fetchLatest()
    });

    setTimeout(() => {
      this.updatePhotos();
    }, this.autoScrollDelay);
  }

  processPhotos(data) {
    data.photos.forEach((photo) => {
      if (!this.uniquePhotos.hasOwnProperty(photo.id)) {
        this.uniquePhotos[photo.id] = photo;
      }
    });

    if (this.firstRender) {
      this.firstRender = false;
      this.updatePhotos();
    }
  }

  afterFetch() {
    super.afterFetch();
  }

  render() {
    this.renderIndex();
    this.renderPhotos(this.photos);
  }

  renderIndex() {
    const renderedIndex = indexTemplate({photos: this.photos, preferences: this.preferences, uuid: this.uuid});
    this.rendered = true

    this.shadow.innerHTML = renderedIndex;
    this.appendCustomCSS();
  }

  renderPhotos(photos) {
    // const renderedPhotos = photosTemplate({mainPhoto: null, otherPhotos: this.otherPhotos, preferences: this.preferences});
    // this.shadow.querySelector('.l2h-photos').innerHTML = renderedPhotos;
    if (this.mainPhoto) {
      this.renderMainPhoto();
    }

    this.renderHeader();
  }

  renderMainPhoto() {
    let prevMainPhotoId = this.mainPhoto ? this.mainPhoto.id : -1;

    if (this.mainPhoto) {
      this.addSmallPhoto();
    }

    this.mainPhoto = this.nextMainPhoto;

    if (this.mainPhoto.id == prevMainPhotoId) {
      return;
    }

    if (!this.rendered) {
      this.renderPhotos(photos);
    }

    const rendered = photoTemplate({photo: this.mainPhoto, preferences: this.preferences});


    let container = this.shadow.getElementById('main-photo');

    let existing = this.shadow.querySelector("#main-photo .l2h-photowrap");
    if (existing) {
      existing.style.opacity = '0';
    }

    container.insertAdjacentHTML('afterbegin', rendered);
    let newMain = this.shadow.querySelector("#main-photo .l2h-photowrap");
    newMain.style.opacity = '1';

  }

  addSmallPhoto() {
    const container = this.shadow.querySelector('#other-photos-container .other-photos');

    // Calculate the width of one photo dynamically
    const imageWidth = container.clientWidth / 8; // since you're showing 4 images side by side

    const renderedSmallPhoto = smallPhotoTemplate({photo: this.mainPhoto, preferences: this.preferences});
    container.insertAdjacentHTML('afterbegin', renderedSmallPhoto);

    const smallPhotoEl = container.firstChild;

    // Adjust the translateX value to slide the photos

    container.offsetWidth;
    // container.style.transform = `translateX(-${imageWidth}px)`;
    smallPhotoEl.classList.remove("newly-added");

    if (container.childElementCount > 9) {
      // Remove the right-most photo after the animation has completed
      setTimeout(() => {
        container.lastChild.remove();
      }, 500);  // 0.5s matches the transition time in the CSS
    }
  }

  bindPhotoEvents() {
    // do nothing
  }

  get nextMainPhoto() {
    let sortedPhotos = Object.values(this.uniquePhotos).sort((a,b) => {
      return (a.views ?? 0) - (b.views ?? 0) || (b.id - a.id)
    });

    let max = 0;
    if (sortedPhotos.length) {
      max = sortedPhotos[sortedPhotos.length - 1].views;
    }

    let selected = sortedPhotos[0];

    console.log("the sorted list is", sortedPhotos.map((x) => [x.id, x.views]));
    console.log("The max is ", max);

    if (!selected.views && max > 1) {
      console.log(`setting photo to count of ${max}`, selected);
      selected.views = max;
    } else {
      selected.views = (selected.views ?? 0) + 1;
      console.log(`setting photo to count of ${selected.views}`, selected);

    }

    return selected
  }
}

customElements.define("l2h-event-widget", EventWidget);
